import React, { PureComponent } from 'react';
import { View, ActivityIndicator } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { Large, Small } from '../../../../components/common/text';
import BlurModal from '../../../../components/common/blur-modal';
import styles from './transaction-advices.styles';
import { PALETTE } from '../../../../constants';
import { PDF } from '@dbk/ui-icons';
import { List, ListItem } from '@dbk/ui-list';
class TransactionAdvice extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      loadingRow: null
    };
    this.modalContent = this.modalContent.bind(this);
    this.closeBlurModel = this.closeBlurModel.bind(this);
  }

  renderAdviceItem(row, portfolioId, index, rowID) {
    const { docType, txnRef, docRefNo, bpId, docPdfSize } = row;
    return (
      <div className={this.state.loadingRow === index ? 'disabled commonWidth' : 'commonWidth'} onClick={this.handlePress.bind(this, bpId, docRefNo, index, rowID)}>
        <div className="row ">
          <div className="columns small-11 medium-11 large-11" id={`txt_transactionAdvice_transaction_advice_test_${index}`}>
            <Large>{txnRef}</Large>
          </div>
          <div className="columns small-1 medium-1 large-1 text-align-right" id={`pdf_transactionAdvice_transaction_advice_test_${index}`}>
            {this.state.loadingRow === rowID ?
              <ActivityIndicator
                animating
                color={PALETTE.primaryText}
                size="large"
              />
              :
              <PDF
                height={30}
                width={30}
                color={PALETTE.secondaryActive}
              />
            }
          </div>
        </div>
      </div >
    );
  }

  handlePress(accId, did, index, rowID) {
    const docId = did;
    const accountId = accId;
    this.setState({ loadingRow: index });
    this.props.getStatementPdf({ accountId, docId }).then((success) => {
      setTimeout(() => {
        this.setState({ loadingRow: null });
      }, 2000);
    });
  }

  modalContent(pdfStr) {
    let url = "data:application/pdf;base64," + pdfStr;
    if (!pdfStr) {
      this.closePdf();
      return (
        <View style={styles.displayPdf}>
          <Large >{messages['app.reports.unablePdf']}</Large>
        </View>
      );
    }
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(pdfStr);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], {
        type: 'application/pdf'
      });
      this.closeBlurModel();
      window.navigator.msSaveOrOpenBlob(blob, 'see-advice');
    } else {
      return (
        <div>
          <embed src={url} width="100%" style={{ 'minHeight': this.props.screen.height - 75 }} />
        </div>
      )
    }
    this.closePdf();
  }

  closePdf() {
    this.setState({ loadingRow: null });
  }
  closeBlurModel() {
    this.props.transact.setEmpty('');
    this.setState({ modal: false });
  }

  render() {
    let adviceList = [];
    const { i18n: { messages } } = this.props;
    if (this.props.transact.selectedAdviceLists != undefined && this.props.transact.selectedAdviceLists != null) {
      adviceList = this.props.transact.selectedAdviceLists;
    }
    const portfolioId = this.props.transact.portfolioId;
    const rowMarkerStyle = { fill: 'transparent' };
    var pdfStr = this.props.transact.pdf;

    return (
      <div>
        <div className="row margin-top-40">
          <div className="columns small-12 small-centered medium-12 medium-centered large-12 large-centered">
            <div className="module">
              {adviceList.length != 0 ?
                <View>
                  <List fullWidth className="listFullHeight">
                    {adviceList.map((item, index, rowID) => (
                      <ListItem>
                        {this.renderAdviceItem(item, portfolioId, index, rowID)}
                      </ListItem>
                    ))}
                  </List>
                  <Text style={styles.seperationBdr} />
                </View>
                :
                <Text style={styles.textAlign}> {messages['app.profile.consolidatesetup.dataRes']} </Text>
              }
              {this.state.modal ? <BlurModal
                visible={this.state.modal}
                doneLabel="Done"
                doneVisible={true}
                onDone={this.closeBlurModel}
              >
                {this.modalContent(pdfStr)}
              </BlurModal> : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TransactionAdvice.propTypes = {
};

export default createContainer({
  $queries: {
    transact: {
      selectedAdviceLists: true,
      portfolioId: true,
      pdf: true,
      setEmpty: { $set: 'pdf' },
    },
    i18n: {
      messages: true,
    },
    getStatementPdf: {
      $call: 'transact.getPdf'
    },
    screen: {
      width: true,
      height: true,
      isSmall: true
    },
  },
})(TransactionAdvice);